import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { storeCreator, initialState } from "./Store";
import {
  decodeBrowserPathToState,
  saveBrowserLocation,
} from "./common/actions";
import {
  startBrowserHistoryListener,
  getLocation,
} from "./common/services/BrowserLocation";
import { basePath } from "./config";
import App from "./containers/App";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import PFATheme from "./PFATheme";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { KeyValue } from "./interfaces";

// redirect users away from legacy /explore page
const hostLookup: KeyValue = {
  "pfabankui-d.app.cloud.gov": "pfabankfindui-d.app.cloud.gov",
  "pfabankui-n.app.cloud.gov": "pfabankfindui-n.app.cloud.gov",
  "pfabankui-q.app.cloud.gov": "pfabankfindui-q.app.cloud.gov",
  "pfabankui.app.cloud.gov": "pfabankfindui.app.cloud.gov",
};
if (
  window.location.pathname.startsWith("/explore") ||
  Object.hasOwn(hostLookup, window.location.host)
) {
  const newOrigin = hostLookup[window.location.host] || window.location.host;
  const pathName = window.location.pathname;
  const path = pathName.startsWith("/explore/failures")
    ? "/bankfind-suite/failures"
    : pathName.startsWith("/explore")
      ? "/bankfind-suite/historical"
      : pathName;
  window.location.href = `${window.location.protocol}//${newOrigin}${path}`;
}
const store = storeCreator(initialState);

// establish listener to apply changes from back-button, etc.
startBrowserHistoryListener(store, basePath, decodeBrowserPathToState);

//Only require react-axe (accessibility tool) in non-prod
if (
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_DISABLE_AXE !== "true"
) {
  const axe = require("react-axe");
  axe(React, ReactDOM, 1000);
}
function BankFind() {
  const store = storeCreator(initialState);

  React.useEffect(() => {
    store.dispatch(saveBrowserLocation(getLocation().pathname));
    // look for any data in the URL to use to set initial state
    if (getLocation().search) {
      // use the supplied URL params if available
      // decodeBrowserPathToState also in turn triggers fetchResults
      store.dispatch(
        decodeBrowserPathToState(store, getLocation().search) as any,
      );
    }
  }, [store]);
  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={PFATheme}>
          <div id="main-content">
            <BrowserRouter basename={basePath}>
              <App />
            </BrowserRouter>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
}

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<BankFind />);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
